import api from './axiosConfig';
const normalizeZip = (zipCode) => String(zipCode !== null && zipCode !== void 0 ? zipCode : '').replace(/[-\s]/g, '');
const isZipLengthSix = (order) => normalizeZip(order.zip_code).length === 6;
const getNumeric = (value) => Number(value) || 0;
const normalizeCourierTabName = (value) => {
    const raw = String(value !== null && value !== void 0 ? value : '').trim();
    if (!raw) {
        return '';
    }
    if (raw.includes('한진')) {
        return raw.includes('택배') ? '한진택배' : '한진';
    }
    if (raw.includes('경동')) {
        return '경동';
    }
    if (raw.includes('천일')) {
        return '천일';
    }
    return raw;
};
const isAccessoryProduct = (order) => { var _a, _b; return String((_b = (_a = order.product_type) !== null && _a !== void 0 ? _a : order.productType) !== null && _b !== void 0 ? _b : '').trim() === '부속품'; };
const isAccessoryCourierTabOrder = (order) => {
    var _a, _b;
    const shipComp = normalizeCourierTabName((_b = (_a = order.ship_comp) !== null && _a !== void 0 ? _a : order.shipComp) !== null && _b !== void 0 ? _b : '');
    return isAccessoryProduct(order) && ['한진', '한진택배', '경동', '천일'].includes(shipComp);
};
const isJejuIsland = (order) => Boolean(order.delivery_area_type) &&
    order.delivery_area_type !== 'N' &&
    getNumeric(order.shipping_fee) < getNumeric(order.ship_comp_fee) * 3;
const isExcludedMall = (order) => {
    var _a;
    const mallId = String((_a = order.mall_id) !== null && _a !== void 0 ? _a : '');
    const excludedMalls = [
        'GS shop',
        'NS홈쇼핑',
        '알리익스프레스',
        '아이디어스',
        '29CM',
        '무신사',
        '텐바이텐',
        '우체국쇼핑',
        '고도몰',
        '롯데'
    ];
    return excludedMalls.some((mall) => mallId.includes(mall));
};
const isHighFee = (order) => {
    var _a;
    const shippingMethod = String((_a = order.shipping_method) !== null && _a !== void 0 ? _a : '');
    return (getNumeric(order.ship_comp_fee) > getNumeric(order.shipping_fee) &&
        ['선불', '착불', '확인요청'].includes(shippingMethod) &&
        !isZipLengthSix(order) &&
        !isExcludedMall(order));
};
const buildTabCounts = (orders) => {
    const tabCounts = {
        all: 0,
        confirm_request: 0,
        common: 0,
        cargo: 0,
        jeju_island: 0,
        high_fee: 0,
        couriers: {},
        accessoryCouriers: {}
    };
    orders.forEach((order) => {
        var _a, _b, _c;
        const shipComp = normalizeCourierTabName((_b = (_a = order.ship_comp) !== null && _a !== void 0 ? _a : order.shipComp) !== null && _b !== void 0 ? _b : '');
        const zipLengthSix = isZipLengthSix(order);
        const highFee = isHighFee(order);
        const isAccessoryCourierOrder = isAccessoryCourierTabOrder(order);
        if (!zipLengthSix) {
            tabCounts.all += 1;
        }
        if (zipLengthSix) {
            tabCounts.confirm_request += 1;
        }
        if (shipComp === '공용' && !zipLengthSix) {
            tabCounts.common += 1;
        }
        if (shipComp === '화물' && !zipLengthSix) {
            tabCounts.cargo += 1;
        }
        if (isJejuIsland(order) && !zipLengthSix) {
            tabCounts.jeju_island += 1;
        }
        if (highFee) {
            tabCounts.high_fee += 1;
        }
        if (shipComp && shipComp !== '공용' && shipComp !== '화물' && !zipLengthSix) {
            const targetBucket = isAccessoryCourierOrder ? tabCounts.accessoryCouriers : tabCounts.couriers;
            const current = (_c = targetBucket[shipComp]) !== null && _c !== void 0 ? _c : { total: 0, visible: 0 };
            current.total += 1;
            if (!highFee) {
                current.visible += 1;
            }
            targetBucket[shipComp] = current;
        }
    });
    return tabCounts;
};
const buildFallbackOrderMetrics = (orders) => ({
    completedCount: orders.filter((order) => {
        var _a;
        return String((_a = order.tracking_number) !== null && _a !== void 0 ? _a : '').trim() !== '' ||
            order.shipping_status === '출고완료';
    }).length,
    waitingCount: orders.filter((order) => order.shipping_status === '출고대기').length,
    totalShippingFee: orders.reduce((sum, order) => sum + getNumeric(order.ship_comp_fee) * Math.max(getNumeric(order.quantity), 1), 0),
    tabCounts: buildTabCounts(orders)
});
// 주문 관리 API 서비스
export const getOrders = async (params) => {
    var _a, _b, _c, _d;
    try {
        const response = await api.get('/api/orders/filtered', { params });
        const orders = response.data.orders || [];
        const fallbackMetrics = buildFallbackOrderMetrics(orders);
        return {
            data: orders,
            total: response.data.total || orders.length,
            completedCount: (_a = response.data.completedCount) !== null && _a !== void 0 ? _a : fallbackMetrics.completedCount,
            waitingCount: (_b = response.data.waitingCount) !== null && _b !== void 0 ? _b : fallbackMetrics.waitingCount,
            tabCounts: (_c = response.data.tabCounts) !== null && _c !== void 0 ? _c : fallbackMetrics.tabCounts,
            totalShippingFee: (_d = response.data.totalShippingFee) !== null && _d !== void 0 ? _d : fallbackMetrics.totalShippingFee
        };
    }
    catch (error) {
        console.error('주문 목록 조회 실패:', error);
        throw error;
    }
};
export const getOrderById = async (id) => {
    try {
        const response = await api.get(`/api/orders/${id}`);
        return response.data.data;
    }
    catch (error) {
        console.error(`주문 상세 조회 실패 (ID: ${id}):`, error);
        throw error;
    }
};
export const createOrder = async (orderData) => {
    try {
        const response = await api.post('/api/orders', orderData);
        return response.data.data;
    }
    catch (error) {
        console.error('주문 생성 실패:', error);
        throw error;
    }
};
export const updateOrder = async (id, orderData) => {
    try {
        const response = await api.put(`/api/orders/${id}`, orderData);
        return response.data.data;
    }
    catch (error) {
        console.error(`주문 수정 실패 (ID: ${id}):`, error);
        throw error;
    }
};
export const updateOrderShip = async (id, orderData) => {
    try {
        const response = await api.get(`/api/orders/ship/${id}`, {
            params: {
                ship_comp: orderData.ship_comp,
                ship_comp_fee: orderData.ship_comp_fee
            }
        });
        return response.data;
    }
    catch (error) {
        console.error(`주문 배송 정보 수정 실패 (ID: ${id}):`, error);
        throw error;
    }
};
export const deleteOrder = async (id) => {
    try {
        await api.delete(`/api/orders/${id}`);
    }
    catch (error) {
        console.error(`주문 삭제 실패 (ID: ${id}):`, error);
        throw error;
    }
};
export const updateOrderStatus = async (id, status) => {
    try {
        const response = await api.patch(`/api/orders/${id}/status`, { status });
        return response.data.data;
    }
    catch (error) {
        console.error(`주문 상태 업데이트 실패 (ID: ${id}):`, error);
        throw error;
    }
};
// 주문 아이템 관리 API 서비스
export const getOrderItems = async (orderId) => {
    try {
        const response = await api.get(`/api/orders/${orderId}/items`);
        return response.data.data;
    }
    catch (error) {
        console.error(`주문 아이템 목록 조회 실패 (주문 ID: ${orderId}):`, error);
        throw error;
    }
};
export const getOrderItemById = async (id) => {
    try {
        const response = await api.get(`/api/order-items/${id}`);
        return response.data.data;
    }
    catch (error) {
        console.error(`주문 아이템 상세 조회 실패 (ID: ${id}):`, error);
        throw error;
    }
};
export const createOrderItem = async (orderItemData) => {
    try {
        const response = await api.post('/api/order-items', orderItemData);
        return response.data.data;
    }
    catch (error) {
        console.error('주문 아이템 생성 실패:', error);
        throw error;
    }
};
export const updateOrderItem = async (id, orderItemData) => {
    try {
        const response = await api.put(`/api/order-items/${id}`, orderItemData);
        return response.data.data;
    }
    catch (error) {
        console.error(`주문 아이템 수정 실패 (ID: ${id}):`, error);
        throw error;
    }
};
export const deleteOrderItem = async (id) => {
    try {
        await api.delete(`/api/order-items/${id}`);
    }
    catch (error) {
        console.error(`주문 아이템 삭제 실패 (ID: ${id}):`, error);
        throw error;
    }
};
export const updateOrderItemStatus = async (id, status) => {
    try {
        const response = await api.patch(`/api/order-items/${id}/status`, { status });
        return response.data.data;
    }
    catch (error) {
        console.error(`주문 아이템 상태 업데이트 실패 (ID: ${id}):`, error);
        throw error;
    }
};
export const updateMultipleOrderItemStatus = async (orderItemIds, status) => {
    try {
        const response = await api.patch('/api/order-items/status', { orderItemIds, status });
        return response.data.data;
    }
    catch (error) {
        console.error('여러 주문 아이템 상태 업데이트 실패:', error);
        throw error;
    }
};
// 인쇄 주문 저장 (목록 선택 출력용)
export const savePrintOrders = async (orderNumbers) => {
    try {
        const response = await api.post('/api/orders/print-orders/save', {
            orderNumbers
        });
        return response.data;
    }
    catch (error) {
        console.error('인쇄 주문 저장 실패:', error);
        throw error;
    }
};
// 인쇄 주문 목록 조회
export const getPrintOrders = async (params) => {
    try {
        const response = await api.get('/api/orders/print-orders', {
            params
        });
        return response.data;
    }
    catch (error) {
        console.error('인쇄 주문 목록 조회 실패:', error);
        throw error;
    }
};
// 특정 날짜의 인쇄 주문 조회
export const getPrintOrdersByDate = async (date) => {
    try {
        const response = await api.get(`/api/orders/print-orders/date/${date}`);
        return response.data;
    }
    catch (error) {
        console.error('특정 날짜 인쇄 주문 조회 실패:', error);
        throw error;
    }
};
// 주문번호로 주문 정보 조회 (PrintWblPopup용)
export const getOrdersByNumbers = async (orderNumbers) => {
    try {
        const response = await api.post('/api/orders/by-numbers', {
            orderNumbers
        });
        return response.data;
    }
    catch (error) {
        console.error('주문번호로 주문 조회 실패:', error);
        throw error;
    }
};
